<div class='flex w-full text-white py-2' style='max-width: 300px'>
  {#each diff_arr as o}
  <div class='text-center w-1/4 rounded shadow px-4 py-3 text-white'>
    <span class='inline-block text-3xl font-bold'>{o.value}</span>
    <span class='inline-block'>{o.label}</span>
  </div>
  {/each}
</div>

<script lang="ts">
import dayjs from 'dayjs'
function cal_diff() {
  const now = dayjs();
  const end = dayjs('2021-05-06T07:00:00+07:00');
  return {
    day: end.diff(now, 'day'),
    hour: end.diff(now, 'hour') % 24,
    minute: end.diff(now, 'minute') % 60,
    second: end.diff(now, 'second') % 60,
  }
}

let diff = cal_diff();
setInterval(() => diff = cal_diff(), 1000)

$: diff_arr = [
  { label: 'วัน', value: diff.day },
  { label: 'ชม', value: diff.hour },
  { label: 'นาที', value: diff.minute },
  { label: 'วินาที', value: diff.second },
]
</script>